<div class="wrap">
  <div class="dual-calendars-wrapper">
    <div class="calendar__opts">
      <div class="custom-select">
        <div class="filter-img-wrapper" #years (click)="isYearsToSelectOpen = !isYearsToSelectOpen;">
          <p class="small">{{ valueOfYearSelect }}</p>
          <img src="/assets/images/arrow-down-black.svg" />
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="years" [cdkConnectedOverlayHasBackdrop]="true"
          (backdropClick)="isYearsToSelectOpen = false" [cdkConnectedOverlayOpen]="isYearsToSelectOpen"
          cdkConnectedOverlayBackdropClass="backdrop-selection" [cdkConnectedOverlayPositions]="positonArea">
          <div class="type-list-wrapper tooltip-specific-release-button" #yearList>
            <div *ngFor="let y of yearNames" class="type-list-item" (click)="selectYear(y.toString())"
              [ngClass]="{ 'type-list-item--disabled': isYearDisabled(y) }">
              <p class="small">{{ y }}</p>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="calendar__body">
      <div class="calendar__months">
        <div *ngFor="let month of monthDic" class="calendar__month" (click)="selectMonthFromSelect(month)" [ngClass]="{'calendar__month--selected': month == selectedMonth.month,
    'calendar__month--disabled': isMonthDisabled(month)}">
          <span>{{ month.he }}</span>
        </div>
      </div>
    </div>
  </div>
</div>